export default __webpack_public_path__ + "static/media/Email- Money transfer.5d21133f.png";